<template>
	<div class="icon_fadein" v-if="showBigIconIndex !== -1">{{ activeIndex }}++
		<img src="@/assets/images/closedown_03.jpg" @click="closeBigIcon" class="close" />
		<div class="box">
			<template v-if="isPc">
				<img src="@/assets/images/prevbtn.png" @click="prev" class="btn prev" />
				<img src="@/assets/images/nextbtn.png" @click="next" class="btn next" />
			</template>
			<template v-else>
				<img src="@/assets/images/prev.png" @click="prev" class="btn prev" />
				<img src="@/assets/images/next.png" @click="next" class="btn next" />
			</template>
			<div class="swiper mySwiper">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item, index) in bigIcons" :key="index"><img :src="item.fileUrlCopy + '?x-image-process=image/resize,w_1200,limit_0'" /></div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "display",
    data() {
        return {
			swiper: null,
			activeIndex: 0
        };
    },
	computed: {
		...mapState({
			showBigIconIndex: state => state.showBigIconIndex,
			bigIcons: state => state.bigIcons
		})
	},
	watch: {
		showBigIconIndex(v) {
			if (v !== -1) {
				this.setSwiper(v)
			}
		}
	},
	methods: {
		setSwiper() {
			const that = this
			this.$nextTick(() => {
				this.swiper = new Swiper('.mySwiper', {
					speed: 600,
					observer: true,
					observeParents: true,
					onTransitionStart: function (swiper) {
						that.activeIndex = this.activeIndex
					},
				})
				this.swiper.slideTo(this.showBigIconIndex)
			})
		},
		closeBigIcon() {
			this.$store.commit('setShowBigIcon', -1)
		},
		prev() {
			this.swiper.slidePrev()
		},
		next() {
			this.swiper.slideNext()
		},
	}
}
</script>

<style lang="less" scoped="scoped">
.icon_fadein {
	width: 100%;
	background: #000000;
	position: fixed;
	left: 0;
	top: 0;
	bottom: 0;
	z-index: 99999999;
	display: flex;
	align-items: center;
	justify-content: center;

	.close {
		width: 2.5vw;
		cursor: pointer;
		position: absolute;
		right: 1.7vw;
		top: 1.3vh;
	}

	.box {
		width: 62.5vw;
		position: relative;

		.btn {
			width: 4.8vw;
			position: absolute;
			top: 50%;
			cursor: pointer;
			transform: translateY(-50%);
			z-index: 9999;

			&.prev {
				left: -1.6rem;
			}

			&.next {
				right: -1.6rem;
			}
		}

		.mySwiper {
			width: 100%;
			overflow: hidden;

			.swiper-slide {
				width: 100%;
				height: auto;

				img {
					display: block;
					width: 100%;
					height: auto;
					object-fit: cover;
				}
			}
		}
	}
}

@media screen and (max-width: 768px) {
	.icon_fadein .box {
		width: 100%;
		height: 4.87rem;
	}

	.close {
		width: .5rem !important;
		right: .2rem !important;
		top: .2rem !important;
	}

	.icon_fadein .box .btn {
		width: .4rem;

		&.prev {
			left: 0.4rem;
		}

		&.next {
			right: 0.4rem;
		}
	}

	.icon_fadein .box .mySwiper .swiper-slide {
		width: 100%;
		height: 4.87rem;
	}
}

</style>


// WEBPACK FOOTER //
// src/components/bigIcon.vue